// Selection transport only. Shopify renders all shipping rules and copy in Liquid.
createComponent('ProductShippingTimelines', () => {
  let currentSelection = null
  let timer
  let controller

  return {
    html: '',
    status: 'loading',

    get selection() {
      if (!this.product.isHydrated) return ''
      const items = [
        ...this.product.allVariants.map(variant => ({
          handle: variant.product.handle,
          id: variant.id,
          quantity: this.product.quantity,
        })),
        ...this.product.stagedAddons.map(item => ({
          handle: item.handle,
          id: item.variantId,
          quantity: item.quantity,
        })),
      ]
      return 'timeline|' + items.map(item => `${item.handle}:${item.id}:${item.quantity}`).join('|')
    },

    refresh(selection, endpoint) {
      if (selection === currentSelection) return
      currentSelection = selection
      clearTimeout(timer)
      controller?.abort()
      this.html = ''
      this.status = 'loading'
      if (!selection) return

      timer = setTimeout(async () => {
        const requestController = new AbortController()
        controller = requestController
        try {
          const url = new URL(endpoint, window.location.origin)
          url.searchParams.set('section_id', 'main-product')
          url.searchParams.set('q', selection)
          const response = await fetch(url, { signal: requestController.signal })
          if (!response.ok) throw new Error('Shipping timelines request failed')
          const document = new DOMParser().parseFromString(await response.text(), 'text/html')
          const content = document.querySelector('[data-shipping-timelines-response]')
          if (!content || content.textContent.includes('Liquid error')) throw new Error('Invalid shipping timelines response')
          if (selection !== currentSelection || requestController.signal.aborted) return
          this.html = content.innerHTML
          this.status = content.querySelector('[data-shipping-group]') ? '' : 'unavailable'
        } catch (error) {
          if (selection !== currentSelection || requestController.signal.aborted) return
          this.status = 'unavailable'
        }
      }, 150)
    },

    dispose() {
      currentSelection = null
      clearTimeout(timer)
      controller?.abort()
    },
  }
})
